import FeedScreen from './FeedScreen';

export default FeedScreen;
